import React, {createContext, ReactNode, useContext, useState} from 'react';

export interface CLPContext {
    isReviewsModalOpen: boolean;
    openReviewsModal: () => void;
    closeReviewsModal: () => void;
    toggleReviewsModal: () => void;
}

const CLPContext = createContext<CLPContext | undefined>(undefined);

interface ClpContextProviderProps {
    children: ReactNode;
}

export const ClpContextProvider: React.FC<ClpContextProviderProps> = ({children}) => {
    const [isReviewsModalOpen, setIsReviewsModalOpen] = useState(false);

    const openReviewsModal = () => setIsReviewsModalOpen(true);
    const closeReviewsModal = () => setIsReviewsModalOpen(false);
    const toggleReviewsModal = () => setIsReviewsModalOpen(!isReviewsModalOpen);

    return (
        <CLPContext.Provider
            value={{
                isReviewsModalOpen,
                openReviewsModal,
                closeReviewsModal,
                toggleReviewsModal,
            }}
        >
            {children}
        </CLPContext.Provider>
    );
};

export function useClpContext(): CLPContext {
    const context = useContext(CLPContext);
    if (!context) {
        throw new Error('useClpContext must be used within a ClpContextProvider');
    }
    return context;
}
